var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          loading: _vm.loading,
          search: _vm.search,
          items: _vm.mysqlUsers
        },
        scopedSlots: _vm._u([
          {
            key: "item.databases",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c("databases-cell", {
                  attrs: {
                    databases: item.databases,
                    user: item.user
                  },
                  on: {
                    "action-completed": function actionCompleted($event) {
                      return _vm.actionCompleted($event)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "item.actions",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      bottom: "",
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function fn(_ref3) {
                            var on = _ref3.on,
                              attrs = _ref3.attrs
                            return [
                              _c(
                                "gg-btn",
                                _vm._g(_vm._b({}, "gg-btn", attrs, false), on),
                                [
                                  _vm._v(" Manage "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        right: ""
                                      }
                                    },
                                    [_vm._v("mdi-chevron-down")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openPrivilegesModal(item)
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Assign to Database")
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openPasswordModal(item)
                              }
                            }
                          },
                          [
                            _c("v-list-item-title", [_vm._v("Change Password")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.openDeleteModal(item)
                              }
                            }
                          },
                          [_c("v-list-item-title", [_vm._v("Delete")])],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.deleteModalOpened
        ? _c("delete-user-modal", {
            attrs: {
              opened: _vm.deleteModalOpened,
              user: _vm.selectedUser
            },
            on: {
              close: _vm.closeDeleteModal,
              "action-completed": function actionCompleted($event) {
                return _vm.actionCompleted($event)
              }
            }
          })
        : _vm._e(),
      _vm.renameModalOpened
        ? _c("rename-user-modal", {
            attrs: {
              opened: _vm.renameModalOpened,
              user: _vm.selectedUser
            },
            on: {
              close: _vm.closeRenameModal,
              "action-completed": function actionCompleted($event) {
                return _vm.actionCompleted($event)
              }
            }
          })
        : _vm._e(),
      _vm.passwordModalOpened
        ? _c("user-password-modal", {
            attrs: {
              opened: _vm.passwordModalOpened,
              user: _vm.selectedUser
            },
            on: {
              close: _vm.closePasswordModal,
              "action-completed": function actionCompleted($event) {
                return _vm.actionCompleted($event)
              }
            }
          })
        : _vm._e(),
      _vm.privilegesModalOpened
        ? _c("add-user-modal", {
            attrs: {
              user: _vm.selectedUser.user,
              mode: "user",
              opened: _vm.privilegesModalOpened
            },
            on: {
              close: _vm.closePrivilegesModal,
              "action-completed": function actionCompleted($event) {
                return _vm.actionCompleted($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }